// extracted by mini-css-extract-plugin
export default {"wrapperRow":"TableHeader_wrapperRow__AXYfp","innerWrapper":"TableHeader_innerWrapper__FnkWW","markerColor":"TableHeader_markerColor__DkaXy"};